import DocsSidebar from './DocsSidebar'
import Logo from '../Logo'

export default function DocsLayout({ locale, section, page, children }) {
  return (
    <div className="min-h-screen bg-zinc-900 text-zinc-100 flex flex-col">
      <header className="border-b border-zinc-700 px-6 py-3 flex items-center justify-between shrink-0 bg-gradient-to-r from-zinc-900 via-zinc-900 to-zinc-800/30">
        <a href="/" className="flex items-center gap-1.5 text-[11px] font-mono text-zinc-300 hover:text-white border border-zinc-600 hover:border-zinc-400 rounded-md px-2.5 py-1 bg-zinc-800/50 hover:bg-zinc-800 transition-colors">
          <span className="text-zinc-300">‹</span> app
        </a>
        <span className="flex items-center gap-2 text-sm font-mono font-semibold text-zinc-300 tracking-wide">
          <Logo variant="mark" size={20} className="shrink-0" />
          Anamnesis Docs
        </span>
        <span />
      </header>

      <div className="flex flex-1 min-h-0">
        <DocsSidebar locale={locale} currentSection={section} currentPage={page} />
        <main className="flex-1 overflow-y-auto px-8 py-6 max-w-3xl">
          {children}
        </main>
      </div>
    </div>
  )
}
